(function(){"use strict";}());

angular.module("app")
    .directive("cutscene", ["AppService","$timeout","$rootScope", "$filter" ,"$document", function(AppService,$timeout,$rootScope,$filter,$document){

        return {
            restrict: "A",
            replace: false,
            scope:{action:"&",pageval:"&",location:"=",resetgame:"&",attempted:"="},
            templateUrl: "views/cutscene.html",
            link: function($scope, element, attributes){
            	var trace = angular.trace;
            	var currentAction;
            	var currentActionIndex = -1;
                  var localPage = null;
                  var waiting = null;
                  var device = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
                  var audioInit = false;

                  var random = Math.round(1000000*Math.random());
            	$timeout(preload,100);
                  //$timeout(initialize,100);

                  $scope.desktop = !device;
                  $scope.loading = true;

                  $rootScope.$watch("audioOn",onAudioStateChange);

                    $scope.toggleVolume = function(){
                        $rootScope.audioOn = !$rootScope.audioOn;
                    };

                    function onAudioStateChange(value){
                      $scope.audioOn = $rootScope.audioOn;
                    }  

                  function onPageChange(event,val){
                        if($scope.scene && $scope.scene.audio) $rootScope.requestBackgroundAudio($scope.scene.audio);
                  }

                  function initialize(){
                        $scope.loading = false;
                        localPage = element.closest(".page").data("page");
                        if(attributes.location || attributes.minigame) initLocation();
                        else if(attributes.cutscene) initStandard();
                        if($scope.scene && $scope.scene.audio && $scope.desktop) $rootScope.requestBackgroundAudio($scope.scene.audio);
                  }
                  function preload() {
                        var images = [];
                        var path;
                        $scope.scenes = AppService.panels[attributes.cutscene];

                        for(var i = 0, count = $scope.scenes.length; i < count; i++){
                              var scene = $scope.scenes[i];
                              var elements = scene.elements;
                              path = $filter("background")(scene.background,$scope.location || $scope.attempted);
                              if(path && images.indexOf(path) === -1) images.push(path);

                              for(var j = 0, numElements = elements.length; j < numElements; j++){
                                    var element = elements[j];
                                    path = element.img;
                                    if(path && images.indexOf(path) === -1) images.push(path);
                              }

                        }


                        preloadImage.bind(images)();
                  }
                  function preloadImage(){
                        if(!this.length) return $scope.$apply(initialize);
                        var image = this.shift();
                        var img = new Image();
                        img.src = image;
                        if(img.complete) return preloadImage.bind(this)();
                        img.onload = preloadImage.bind(this);
                        img.onerror =  preloadImage.bind(this);
                  }
                  function initStandard(){
                        if(!AppService.panels)
                        {
                              waiting = $timeout(initStandard,50);
                              return;
                        }
                        else if(waiting){
                              waiting.cancel();
                              waiting = null;
                        }

                        $scope.scenes = AppService.panels[attributes.cutscene];
                        $scope.id = attributes.cutscene;
                        $scope.transitioning = false;
                        $scope.classes = {transitioning:false};
                        setScene($scope.scenes[0]);
                  }
                  function initLocation(){
                        var value = $scope.location;
                        var type = "locationChange";

                        if(!AppService.panels)
                        {
                              waiting = $timeout(function(){initLocation(type,value);},50);
                              return;
                        }
                        else if(waiting){
                              waiting.cancel();
                              waiting = null;
                        }

                        var panel = value.correct ? (attributes.minigame ? value["mini-game"].intro : value.panel) : value.panel; //value["mini-game"].intro
                        $scope.scenes = AppService.panels[panel];
                        $scope.id = panel;
                        $scope.transitioning = false;
                        $scope.classes = {transitioning:false};
                        setScene($scope.scenes[0]);
                  }
                  function onLocationChange(type,value){
                        if(!attributes || (!attributes.location && !attributes.minigame)) return;
                        if(!AppService.panels)
                        {
                              waiting = $timeout(function(){onLocationChange(type,value);},50);
                              return;
                        }
                        else if(waiting){
                              waiting.cancel();
                              waiting = null;
                        }

                        var panel = value.correct ? (attributes.minigame ? value["mini-game"].intro : value.panel) : value.panel; //value["mini-game"].intro
                        
                        $scope.scenes = AppService.panels[panel];
                        $scope.id = panel;
                        $scope.transitioning = false;
                        $scope.classes = {transitioning:false};
                        setScene($scope.scenes[0]);
                  }     

            	$scope.nextAction = function(){
                        //var player = $document.find("#global-audio");
                        //player.find("source").eq(0).attr("src","audio/Button_Select.mp3");
                        //player.get(0).load();



            		currentActionIndex++;
            		currentAction = $scope.actions[currentActionIndex];
                        $rootScope.$emit("audio","Button_Select");
            		if(!currentAction) return advanceScene();
                        if(!audioInit && !$scope.desktop && $scope.scene.audio){
                              audioInit = true;
                              $rootScope.requestBackgroundAudio($scope.scene.audio);
                        }
                        $scope.showReplayButton = currentAction.length ? currentAction[0].showReplayButton : false;
            		generateCSS();
            	};

            	$scope.previousAction = function(){
            		if(currentActionIndex > 0) currentActionIndex --;
            		currentAction = $scope.actions[currentActionIndex];
                         $rootScope.$emit("audio","Button_Select");
            		if(!currentAction) return rewindScene();
            		generateCSS();
            	};

                  $scope.skip = function(){
                        var scene = $scope.scenes[$scope.scenes.length-1];
                        var page = $scope.pageval({value:scene.divertIfWrong && !$scope.location.correct ? scene.divertIfWrong : scene.advanceToScreen});
                        if(attributes.final === "true") return $scope.resetgame();
                        $scope.action({page:page});
                  };

            	function rewindScene(){
            		var index = $scope.scenes.indexOf($scope.scene);

            		if(index > 0) 
            		{
            			$scope.transition = element.find(".cutscene-container").html();
            			$scope.transition += "<style> div.transition-container{ background: url("+$scope.background+") no-repeat; background-size:cover;}</style>";
            			$scope.classes.transitioning = true;
            			$scope.scenes[index-1].rewinding = true;
            			$timeout(transition.bind($scope.scenes[index-1]),500);
            		}
            	}

            	function advanceScene(){
            		var index = $scope.scenes.indexOf($scope.scene);
                        audioInit = false;

            		if(index < $scope.scenes.length - 1) 
            		{
                              var path = $filter("background")($scope.background,$scope.location);
            			$scope.transition = element.find(".cutscene-container").html();
            			$scope.transition += "<style> div.transition-container{ background: url("+path+") no-repeat; background-size:cover;}</style>";
            			$scope.classes.transitioning = true;
            			$scope.scenes[index+1].rewinding = false;
            			$timeout(transition.bind($scope.scenes[index+1]),500);
                              if(!audioInit && !$scope.desktop && $scope.scenes[index+1].audio){
                                    audioInit = true;
                                    $rootScope.requestBackgroundAudio($scope.scenes[index+1].audio);
                              }
            		}
            		else{
            			var page = $scope.pageval({value:$scope.scene.divertIfWrong && !$scope.location.correct ? $scope.scene.divertIfWrong : $scope.scene.advanceToScreen});
                              if(attributes.final === "true") return $scope.resetgame();
	            		$scope.action({page:page});
            		}
            	}

            	function transition(){
            		setScene(this);
            		$timeout(function(){
            			$scope.classes.transitioning = false;
            		},0);
            	}

            	function setScene(scene){
                        var path = $filter("background")(scene.background,$scope.location || $scope.attempted);
            		$scope.scene = scene;
	            	$scope.elements = $scope.scene.elements;
	            	$scope.actions = $scope.scene.actions;
	            	$scope.background = path;
                        $scope.backgroundStyle = $scope.scene.backgroundStyle;
                        if($scope.scene.audio) $rootScope.requestBackgroundAudio($scope.scene.audio);
	            	currentActionIndex = -1; //scene.rewinding ? $scope.actions.length - 1 : -1;
	            	generateCSS();
            	}

            	function generateCSS(){
            		for(var i = 0, count = $scope.elements.length; i < count; i++){
            			var target = $scope.elements[i];
            			var info = getPositionInfo(target);
            			if(!info) continue;
            			if(!target.info) target.info = {};
            			angular.extend(target.info,info);
            			target.css = "div#app-container #"+$scope.id + "-" + target.id + "{ ";
            			for(var prop in target.info){
            				var rule = target.info[prop];
            				if(prop.match(/__/gim)) continue;
            				target.css += (" " + prop + ": " + rule + "; "); 
            			}
            			if(target.img) target.css += " background:url("+target.img+") no-repeat; background-size:cover; ";
            			if(info.__speed__) target.css += "transition: all " + info.__speed__+ " ease-out; ";
            			
                              if(info.__delay__) target.css += "transition-delay: " + info.__delay__ + "; ";
                              //if(info.__html__) target.html = info.__html__;
                              //else target.html = null;
                              target.displayHTML = info.__html__ || target.html;

                              if(info.__delay__ && info.__audio__) $timeout(emitAudio.bind(info),parseInt(info.__delay__)*1000);
                              else if(info.__audio__) emitAudio.bind(info)();

            			target.css += "}";
            		}

            	}
                  function emitAudio(){
                        $rootScope.$emit("audio",this.__audio__);
                  }

            	function getPositionInfo(element){
            		var id = element.id;
            		var i,count,item;

            		if(currentAction){
            			for(i = 0, count = currentAction.length; i < count; i++){
            				item = currentAction[i];
            				if(item.target == element.id) return convertToObject(item.to,item);
            			}
            			return null;
            		}	
            		return convertToObject(element.origin);
            	}

            	function convertToObject(info,action){
            		var array = info ? info.split(";") : [];
            		var object = {};

            		if(action) {
            			object.__speed__ = action.speed;
            			object.__delay__ = action.delay;
            			object.__html__ = action.html;
                              object.__audio__ = action.audio;
            		}
            		for(var i = 0, count = array.length; i < count; i++){
            			var css = array[i];
            			if(css.replace(/\s+/gim,"").length === 0) continue;
            			css = css.replace(/^\s+/gim,"");
            			css = css.split(":");
            			object[css[0]] = css[1]; 
            		}
            		return object;
            	}	
            }
        };

    }]);
